<template>
  <el-col :span="24" id="pos" v-loading.body="changingPage && !navigating" element-loading-text="Fetching page...">
    <el-row type="flex" justify="start" align="middle" id="pos-header">
      <HeaderInfoText :colspan="9" title="PURCHASE ORDERS" :meta="meta" :selection="selection" />
      <el-col :span="6">
        <el-row type="flex" justify="center" v-if="meta.count > 20">
          <el-pagination
            layout="prev, pager, next, jumper"
            :total="meta.count"
            :page-size="20"
            @current-change="changePage"
            :current-page="currentPage"
          />
        </el-row>
      </el-col>
      <el-col :span="9" class="h-padded right-aligned-col">
        <div style="display:inline-block;">
          <el-select
            v-if="meta.count"
            :disabled="!(selection && selection.length)"
            placeholder="With selected..."
            v-model="actionFilterSelection"
            style="padding: 0 6px;"
            @change="handleActionFilterSelection">
            <el-option
              v-for="(option, i) in actionFilters"
              :key=i
              :label="option.text"
              :value=i
              :disabled="option.disabled">
            </el-option>
          </el-select>
          <el-button plain @click="toggleFilters" style="margin-left: 0;">
            {{ showFilters ? "Hide filters" : "Show filters" }}
          </el-button>
          <router-link :to="{name: 'NewPo'}">
            <el-button type="primary" icon="plus" />
          </router-link>
        </div>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center" align="middle" style="padding: 0 12px;">
      <Filters
        ref="filters"
        :filters="filters"
        :filtersVisible="showFilters"
        :filterSize="4"
        :autoApply="false"
        clearAction="clearPoState"
        clearMetadataAction="resetPoMeta"
        searchAction="fetchPosWithQuery"
        transactionType="Po"
        :lineFieldSearch="otherNameFieldEnabled ? { field: 'other_name', transactionType: 'po' } : null"
        @filterCleared="() => $refs.filters.applyFilters()"
        @doneFiltering="getAppliedFilters">
        <template v-for="(f, i) in filters" :slot="`${f.type}${i}`" slot-scope="props">
          <component :key="i" :is="f.type" :properties="f.props" :ref="`${f.type+'_po_ref'}`" />
        </template>
      </Filters>
    </el-row>
    <el-row type="flex" justify="end" align="middle">
      <el-col>
        <el-row type="flex">
          <TransactionsConfList v-if="pos" name="po_transactions_conf_list" ref="transactions_conf_list" :aggridColumns="aggridColumns"
          :rows="pos" :emitSelect="true" @onSelect="handleSelectionChange" :currentPage="currentPage"/>
        </el-row>
        <el-row v-if="!meta.count" align="middle" justify="center" class="nodata-heading">
          No data available
        </el-row>
      </el-col>
    </el-row>
    <el-dialog
      title=""
      :visible.sync="sendEmailVisible"
      size="large"
      :show-close="true"
      :close-on-press-escape="true"
      @close="closeSendEmailModal">
      <el-row type="flex" align="middle" justify="end" style="border-bottom: 1px solid lightgrey;">
        <HeaderInfoText :colspan="12" title="Send Email" />
        <el-col>
          <el-row type="flex" align="middle" justify="end">
            <el-button type="primary" @click="cancelSendEmail" style="margin: 0 15px;">Cancel</el-button>
            <el-button type="primary" @click="sendEmail" style="margin: 0 15px;">Send Email</el-button>
          </el-row>
        </el-col>
      </el-row>
      <nacha-po-conf-list
        v-show="sendEmailVisible && selectedPos && !emailLoading"
        name="nacha_po_conf_list"
        ref="nacha_po_conf_list"
        :allow-edit="true"
        :allow-notify="false"
        :width="width"
        :height="height"
        :row-data="selectedPos"
        @onSelect="handleSelectedConf"
        @updateCCMail="handleUpdateCCMail"
        @updateFileAttachment="handleUpdateFileAttachment"
      />
      <div v-if="emailLoading" style="min-height: 100px;" v-loading="emailLoading" element-loading-text="Loading..." />
      <el-row v-if="!selectedPos && !selectedPos.length" align="middle" justify="center" class="nodata-heading">
        No data available
      </el-row>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="sendEmailVisible"
      size="large"
      :show-close="true"
      :close-on-press-escape="true"
      @close="closeSendEmailModal">
      <el-row type="flex" align="middle" justify="end" style="border-bottom: 1px solid lightgrey;">
        <HeaderInfoText :colspan="12" title="Send Email" />
        <el-col>
          <el-row type="flex" align="middle" justify="end">
            <el-button type="primary" @click="cancelSendEmail" style="margin: 0 15px;">Cancel</el-button>
            <el-button type="primary" @click="sendEmail" style="margin: 0 15px;">Send Email</el-button>
          </el-row>
        </el-col>
      </el-row>
      <nacha-po-conf-list
        v-if="sendEmailVisible && selectedPos"
        name="nacha_po_conf_list"
        ref="nacha_po_conf_list"
        :allow-edit="true"
        :allow-notify="false"
        :width="width"
        :height="height"
        :row-data="selectedPos"
        @onSelect="handleSelectedConf"
        @updateCCMail="handleCellUpdate"
      />
      <el-row v-if="!selectedPos && !selectedPos.length" align="middle" justify="center" class="nodata-heading">
        No data available
      </el-row>
    </el-dialog>
  </el-col>
</template>

<script>
  import store from '@/store/store'
  import { mapGetters } from 'vuex'
  import Filters from '@/components/RetainedFilters.vue'
  import KeywordFilter from '@/components/FilterComponents/KeywordFilter'
  import SelectFilter from '@/components/FilterComponents/SelectFilter'
  import AutocompleteFilter from '@/components/FilterComponents/AutocompleteFilter'
  import HeaderInfoText from '@/components/HeaderInfoText'
  import { notify } from '@/utils/helpers/Notify'
  import { listViewMixins } from '@/Mixins/TransactionListViews'
  import TransactionsConfList from '@/components/SigmaClientNew/TransactionsConfList.vue'
  import NachaPoConfList from '@/components/SigmaClientNew/NachaPoConfList.vue'

  export default {
    components: {
      Filters,
      KeywordFilter,
      SelectFilter,
      AutocompleteFilter,
      HeaderInfoText,
      TransactionsConfList,
      NachaPoConfList
    },
    mixins: [ listViewMixins ],
    data () {
      return {
        tableHeight: 500,
        showFilters: true,
        statusValues: [],
        selection: [],
        closing: false,
        actionFilterSelection: null,
        sendEmailVisible: false,
        selectedPos: [],
        ccMail: [],
        emailLoading: false,
        aggridColumns: ['rowSelect', 'idColumn', 'numberColumn', 'descriptionColumn', 'batchColumn', 'vendorColumn', 'currencyColumn', 'originalAmountColumn', 'remainingAmountColumn', 'actionsColumn'],
        selectedStatuses: ['DRAFT', 'OPEN', 'AUDITED', 'POSTED', 'CLOSED', 'VOIDED'],
        statusOptions: [
          { label: 'DRAFT', value: 'DRAFT' },
          { label: 'OPEN', value: 'OPEN' },
          { label: 'AUDITED', value: 'AUDITED' },
          { label: 'POSTED', value: 'POSTED' },
          { label: 'CLOSED', value: 'CLOSED' },
          { label: 'VOIDED', value: 'VOIDED' },
          { label: 'DELETED', value: 'DELETED' }
        ]
      }
    },
    methods: {
      getAppliedFilters () {
        this.$store.dispatch('clearSetPoFilterInfo')
        sessionStorage.setItem('paginationQuery', JSON.stringify({page: this.currentPage, ...this.$refs.filters.getFilters}))
        this.$store.dispatch('setPoFilterInfo', { page: this.currentPage, ...this.$refs.filters.getFilters })
      },
      /**
       * Handles transaction selection
       * @param selection
       */
      async handleSelectionChange (selection) {
        let notThisPage = this.selection.filter(v => v.page !== this.currentPage)
        this.selection = [...notThisPage, ...selection]
        let promises = []
        this.selection.forEach(selection => {
          if (selection.status === 'POSTED' && selection.lines.length) { // Fetching lines to validate close po
            promises.push(this.$store.dispatch('fetchPoLinesWithQuery', { id__in: selection.lines, page_size: selection.lines.length }))
          }
        })
        if (this.actionFilterSelection) {
          this.actionFilterSelection = null
        }
        await Promise.all(promises)
      },
      /**
       * Closes selected POs
       */
      async closeSelected () {
        try {
          this.closing = true
          const promises = this.filteredToClose.map(v => {
            this.$store.dispatch('updatePo', { id: v.id, data: { status: 'CLOSED' } })
              .then(r => {
                if (r && r.data && r.data.id) {
                  this.selection = this.selection.filter(po => po.id !== r.data.id)
                }
              })
          })
          const resp = await Promise.all(promises)
          if (resp && resp.length) {
            this.selection = []
            notify(this, 'success', 'Purchase Orders Closed')
          }
        } catch (e) {
          console.log(e)
          notify(this, 'danger', 'Error closing selected POs')
        } finally {
          this.actionFilterSelection = null
          this.closing = false
        }
      },
      closeSendEmailModal () {
        this.sendEmailVisible = false
        this.ccMail = []
        if (this.actionFilterSelection) {
          this.actionFilterSelection = null
        }
      },
      async emailSelected (e) {
        this.emailLoading = true
        this.sendEmailVisible = true
        this.ccMail = []
        this.selectedPos = this.selection.map(item => {
          let company = this.getCompanyById(item.batch_data.company)
          return {
            attributes: {
              po_id: item.id,
              vendor_id: item.vendor,
              vendor_name: item.vendor_data.name,
              email: item.vendor_data.email,
              amount_decimal: item.amount_decimal,
              number: item.number,
              description: item.description,
              file_attachment: true,
              resources: [{attributes: {company_email: company.email}}],
              company_email: company.email,
              cc_mail: ''
            }
          }
        })
        this.emailLoading = false
      },
      async sendEmail () {
        try {
          this.emailLoading = true
          let posSelected = []
          let selectedPosWithEmail = []
          let selectedPosWithOutEmail = []
          selectedPosWithEmail = this.selectedPos.filter((obj) => { return obj.attributes.email })
          selectedPosWithOutEmail = this.selectedPos.filter((obj) => { return !obj.attributes.email })
          if (this.selectedPos.length) {
            selectedPosWithEmail.forEach((mail) => {
              let item = {
                id: mail.attributes.po_id,
                file_attachment: mail.attributes.file_attachment,
                cc_mail: false
              }
              if (mail.attributes.cc_mail) {
                item.cc_mail = true
              }
              posSelected.push(item)
            })
            if (posSelected.length) {
              const newPayload = Object.assign({}, { purchase_order: posSelected })
              const resp = await this.$store.dispatch('notifyPos', newPayload)
              if (resp && resp.success.vendors.length) {
                notify(this, 'success', 'Email sent to ' + resp.success.vendors.map((vendor) => vendor.name).join(', '), 10)
                this.emailLoading = false
              }
            }
            // notify if vendors do not have emails
            if (selectedPosWithOutEmail.length) {
              notify(this, 'error', 'Unable to send email to ' + selectedPosWithOutEmail.map((po) => po.attributes.vendor_name).join(', '), 100)
              this.emailLoading = false
            }
          } else {
            this.emailLoading = false
            notify(this, 'error', 'Error sent email')
            return false
          }
        } catch (e) {
          console.log(e)
          this.emailLoading = false
          notify(this, 'error', 'Error sent email')
          return e
        }
      },
      cancelSendEmail () {
        this.sendEmailVisible = false
        this.ccMail = []
        if (this.actionFilterSelection) {
          this.actionFilterSelection = null
        }
      },
      handleSelectedConf (selection, index) {
        this.selectedPos[index].attributes.cc_mail = selection
        this.selectedPos[index].attributes.file_attachment = selection
      },
  
      handleUpdateCCMail (param, index) {
        this.selectedPos[index].attributes.cc_mail = param.newValue
      },
      handleUpdateFileAttachment (param, index) {
        this.selectedPos[index].attributes.file_attachment = param.newValue
      },
      /**
       * Handles action filter selections
      */
      async handleActionFilterSelection (selectedOpt = null) {
        try {
          switch (selectedOpt) {
            case 0:
              this.sendEmailVisible = false
              this.closeSelected()
              break
            case 1:
              this.emailSelected()
          }
        } catch (e) {
          console.log(e)
        }
      },
      /**
       * Handles paginating between AP pages
       * @param page  Target page
       */
      async changePage (page) {
        try {
          await this.$store.dispatch('setPoFilterInfo', { ...this.$refs.filters.getFilters, ...{ page: page } })
          // Get FilterInfo from the store data
          let filterStoreData = this.getPoFilterInfo
          if (Object.keys(filterStoreData).length) {
            this.filterRetained()
            return
          }
          this.changingPage = true
          const { currentFilters } = this
          let payload = currentFilters && Object.keys(currentFilters).length
            ? Object.assign({}, { query: { ...currentFilters, page }, storeLines: false })
            : Object.assign({}, { query: { page }, storeLines: false })
          await this.$store.dispatch('clearPoState', [])
          await this.$store.dispatch('setPoFilterInfo', { page: page, ...this.currentFilters })
          const entities = await this.$store.dispatch('fetchPosWithQuery', payload)
          if (entities) {
            const promises = await this.$store.dispatch('findDependencies', entities)
            await Promise.all(promises)
          }
          await new Promise((resolve, reject) => {
            setTimeout(() => {
              this.changingPage = false
              resolve()
            })
          })
          this.$refs['transactions_conf_list'].restoreSelection(this.selection)
        } catch (e) {
          console.log(e) // TODO: use a logger
          this.changingPage = false
        }
      },
      async filterRetained () {
        this.changingPage = true
        // Get FilterInfo from the store data
        let filterStoreData = this.$store.getters.getPoFilterInfo
        if (!Object.keys(filterStoreData).length) {
          const query = { status__in: this.selectedStatuses }
          for (let f in this.currentFilters) {
            if (!query.hasOwnProperty(f)) {
              query[f] = this.currentFilters[f]
            }
          }
          const entities = await store.dispatch('fetchPosWithQuery', { query, storeLines: false })
          await store.dispatch('setFilter', query)
          sessionStorage.setItem('paginationQuery', JSON.stringify({page: this.currentPage, ...query}))
          await this.$store.dispatch('setPoFilterInfo', { ...query, ...{ page: this.currentPage } })
          const promises = await store.dispatch('findDependencies', entities)
          await Promise.all(promises)
          this.changingPage = false
          return
        } else {
          sessionStorage.setItem('paginationQuery', JSON.stringify({page: this.currentPage, ...filterStoreData}))
        }
        try {
          const { currentFilters } = this
          // Prepare payload query to append to the API
          let payload = currentFilters && Object.keys(currentFilters).length
            ? Object.assign({}, { query: { ...currentFilters, page: filterStoreData['page'] ? filterStoreData['page'] : this.currentPage }, storeLines: false })
            : Object.assign({}, { query: { page: filterStoreData['page'] ? filterStoreData['page'] : this.currentPage }, storeLines: false })
          // Check 'keyword' value is exist or not, if exists then assing the value
          if (filterStoreData && filterStoreData['keyword'] && filterStoreData['keyword'].length > 0) {
            payload.query['search'] = filterStoreData['keyword']
          }
          // Check 'status__in' value is exist or not, if exists then assing the value
          if (filterStoreData && filterStoreData['status__in'] && filterStoreData['status__in'].length > 0) {
            payload.query['status__in'] = filterStoreData['status__in']
          }
          // Check 'batch' value is exist or not, if exists then assing the value
          if (filterStoreData && filterStoreData['batch'] && filterStoreData['batch'].length > 0) {
            payload.query['batch'] = filterStoreData['batch']
          }
          // Check 'vendor' value is exist or not, if exists then assing the value
          if (filterStoreData && filterStoreData['vendor'] && filterStoreData['vendor'].length > 0) {
            payload.query['vendor'] = filterStoreData['vendor']
          }
          // Check 'vendor' value is exist or not, if exists then assing the value
          if (filterStoreData && filterStoreData['batch__bank__currency__in'] && filterStoreData['batch__bank__currency__in'].length > 0) {
            payload.query['batch__bank__currency__in'] = filterStoreData['batch__bank__currency__in']
          }
          // Reset PO data
          await Promise.all([
            store.dispatch('resetPoMeta'),
            store.dispatch('clearPoState', true),
            store.dispatch('fetchUiSetting', { name: 'LINE_FIELD_ORDER' })
          ])
          // Get PO's data based on the filter query
          const entities = await store.dispatch('fetchPosWithQuery', payload)
          const promises = await store.dispatch('findDependencies', entities)
          await Promise.all(promises)
          await new Promise((resolve, reject) => {
            setTimeout(() => {
              this.changingPage = false
              resolve()
            })
          })
          // Prefill the data for the filters
          if (this.filters && this.filters.length && this.$refs) {
            this.$nextTick(() => {
              // Check 'keywordFilter_po_ref' is exist or not, if exists then assing the value to prefill it
              if (this.$refs && this.$refs.keywordFilter_po_ref && filterStoreData['keyword'] && filterStoreData['keyword'].length > 0) {
                this.$refs.keywordFilter_po_ref[0].keyword = filterStoreData['keyword']
                this.$refs.keywordFilter_po_ref[0].change()
              }
              // Check 'selectFilter_po_ref' is exist or not, if exists then assing the value to prefill it
              if (this.$refs && this.$refs.selectFilter_po_ref && filterStoreData['status__in'] && filterStoreData['status__in'].length > 0) {
                this.$refs.selectFilter_po_ref[0].selectedVal = filterStoreData['status__in']
                this.$refs.selectFilter_po_ref[0].change()
              }
                // Check 'selectFilter_po_ref' is exist or not, if exists then assing the value to prefill it
              if (this.$refs && this.$refs.selectFilter_po_ref && filterStoreData['batch__bank__currency__in'] && filterStoreData['batch__bank__currency__in'].length > 0) {
                this.$refs.selectFilter_po_ref[1].selectedVal = filterStoreData['batch__bank__currency__in']
                this.$refs.selectFilter_po_ref[1].change()
              }
              // Check 'autocompleteFilter_ref' is exist or not, if exists then assing the value to prefill it
              if (this.$refs && this.$refs.autocompleteFilter_po_ref && filterStoreData && ((filterStoreData['batch'] && filterStoreData['batch'].length > 0) || (filterStoreData['vendor'] && filterStoreData['vendor'].length > 0))) {
                // Check 'batch' data is exist or not, if exists then assing the value to prefill it
                if (filterStoreData && filterStoreData['batch']) {
                  let batchInfo = this.getBatchById([filterStoreData['batch']])
                  this.$refs.autocompleteFilter_po_ref[0].keyword = batchInfo.name
                  this.$refs.autocompleteFilter_po_ref[0].handleSelect({label: batchInfo.name, value: batchInfo.id})
                }
                // Check 'vendor' data is exist or not, if exists then assing the value to prefill it
                if (filterStoreData && filterStoreData['vendor']) {
                  let vendorInfo = this.getVendorById([filterStoreData['vendor']])
                  this.$refs.autocompleteFilter_po_ref[1].keyword = vendorInfo.name
                  this.$refs.autocompleteFilter_po_ref[1].handleSelect({label: vendorInfo.name, value: vendorInfo.id})
                }
              }
            })
          }
        } catch (e) {
          console.log(e)
          this.changingPage = false
        }
      }
    },
    computed: {
      ...mapGetters({
        pos: 'getPos',
        meta: 'getPoMetadata',
        getPoLinesByTransactionId: 'getPoLinesByTransactionId',
        currentPage: 'getCurrentPoPage',
        getBatchById: 'getBatchById',
        getVendorById: 'getVendorById',
        getCurrencyByBatchId: 'getCurrencyByBatchId',
        getCompanyById: 'getCompanyById',
        getcurrentFilters: 'getFilters',
        getPoFilterInfo: 'getPoFilterInfo'
      }),
      width () {
        // Reducing by 3 % to handle sigma-frontend navbar
        return '100%'
      },
      height () {
        // Reducing by 3 % to handle sigma-frontend navbar
        return window.innerHeight * 0.63 + 'px'
      },
      filteredToClose () {
        if (!this.selection.length) return []
        let selectionFilters = []
        for (let i = 0; i < this.selection.length; i++) {
          if (['DRAFT', 'OPEN', 'AUDITED'].includes(this.selection[i].status)) {
            selectionFilters.push(this.selection[i])
          } else if (['POSTED'].includes(this.selection[i].status)) {
            let poLines = Object.values(this.getPoLinesByTransactionId(this.selection[i].id))
            if (poLines.some(v => ['OPEN', 'PARTIAL'].includes(v.type))) {
              selectionFilters.push(this.selection[i])
            } else {
              selectionFilters = []
              break
            }
          }
        }
        return selectionFilters
      },
      /**
       * Determines whether the 'other_name' line field is enabled in admin settings
       * @return {boolean}
       */
      otherNameFieldEnabled () {
        let fieldOrderSetting
        try {
          fieldOrderSetting = JSON.parse(this.$store.getters.getUiSettings['LINE_FIELD_ORDER'])
        } catch (e) {
          if (e instanceof Error && e.name === 'SyntaxError') {
            console.log('Error decoding JSON when getting LINE_FIELD_ORDER setting')
          }
        }
        if (!(fieldOrderSetting && fieldOrderSetting.po && fieldOrderSetting.po.other_name)) {
          return false
        }
        return !fieldOrderSetting.po.other_name.hidden
      },
      actionFilters () {
        return [
          {
            text: 'Close Selected',
            type: 'close',
            disabled: !(this.filteredToClose && this.filteredToClose.length)
          },
          {
            text: 'Email Selected',
            type: 'email',
            disabled: !(this.selection && this.selection.length)
          }
        ]
      },
      filters () {
        return [
          {
            type: 'keywordFilter',
            props: {}
          },
          {
            type: 'selectFilter',
            props: {
              filterName: 'status',
              clearable: true,
              opts: this.statusOptions || [],
              defaults: this.selectedStatuses || [],
              multi: true,
              placeholder: 'Status'
            }
          },
          {
            type: 'autocompleteFilter',
            props: {
              filterName: 'batch',
              remote: true,
              clearable: true,
              action: 'fetchBatchesWithQuery',
              clearAction: 'clearBatchState',
              getter: 'getBatchesBySearchCriteria',
              triggerOnFocus: false,
              placeholder: 'Batch',
              queryParamType: 'search',
              suggestionLabelAttr: 'name'
            }
          },
          {
            type: 'autocompleteFilter',
            props: {
              filterName: 'vendor',
              remote: true,
              clearable: true,
              action: 'fetchVendorsWithQuery',
              clearAction: 'clearVendorState',
              getter: 'getVendorsBySearchCriteria',
              triggerOnFocus: false,
              placeholder: 'Vendor',
              queryParamType: 'search',
              suggestionLabelAttr: 'name'
            }
          },
          {
            type: 'selectFilter',
            props: {
              filterName: 'batch__bank__currency',
              clearable: true,
              opts: this.$store.getters.getAllCurrencies.map(c => ({ label: c.code, value: c.id })),
              multi: true,
              placeholder: 'Currency',
              styles: '0 4px'
            }
          }
        ]
      }
    },
    mounted () {
      const tableHeight = () => {
        const parentHeight = document.getElementById('pos').offsetHeight
        const headerHeight = document.getElementById('pos-header').offsetHeight
        return parentHeight - headerHeight
      }
      this.tableHeight = tableHeight()
    },
    beforeDestroy () {
      this.$store.dispatch('updateTransactionSelection', [])
      this.$store.dispatch('updateFilteredTransactionSelection', [])
    },
    async beforeRouteEnter (to, from, next) {
      try {
        await Promise.all([
          store.dispatch('resetPoMeta'),
          store.dispatch('clearPoState'),
          store.dispatch('fetchUiSetting', { name: 'LINE_FIELD_ORDER' })
        ])
      } catch (e) {
        console.log(e)
      } finally {
        next(vm => {
          vm.filterRetained()
        })
      }
    },
    async beforeRouteLeave (to, from, next) {
      try {
        await store.dispatch('clearPoState', true)
      } catch (e) {
        console.log(e)
      } finally {
        next()
      }
    }
  }
</script>

<style scoped>
  #pos-header {
    border-bottom: 1px solid lightgray;
  }
  .h-padded {
    padding: 0 12px;
  }
  .left-aligned-col {
    text-align: left;
  }
  .right-aligned-col {
    text-align: right;
  }
  .el-table .modified-row {
    background: #c9e5f5;
  }
  .nodata-heading {
    padding: 60px 0;
    color: #a7a7a7;
    font-size: 24px;
  }
  a, a:visited {
    text-decoration: none;
    color: rgb(0, 0, 238) !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/RouteComponents/Pos/Pos.vue